
import React, { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Upload } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

interface FileUploadSectionProps {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isProcessing: boolean;
}

export const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  onFileChange,
  isProcessing
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  
  return (
    <div className="flex flex-col gap-4">
      <Alert className="bg-blue-50 border-blue-200">
        <Info className="h-4 w-4 text-blue-500" />
        <AlertDescription>
          Your Excel file must have a column with the header "name" (case-sensitive) containing the category names.
        </AlertDescription>
      </Alert>
      
      <div className="flex flex-wrap gap-4">
        <Button
          onClick={() => fileInputRef.current?.click()}
          disabled={isProcessing}
          variant="outline"
        >
          <Upload className="h-4 w-4 mr-2" />
          Select Excel File
        </Button>
        
        <p className="text-sm text-muted-foreground mt-1">
          Upload an Excel spreadsheet (.xlsx or .xls) with a "name" column.
        </p>
      </div>
      
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls"
        onChange={onFileChange}
        className="hidden"
      />
    </div>
  );
};
